export default __webpack_public_path__ + "static/gradient-ae8424e263adfca6549ca77bdbd18f3b.svg";